module.exports = __webpack_public_path__ + "img/hr-tree-09-b-leaves.cdec5382.png";